export default __webpack_public_path__ + "img/img_matias_muelas-693722337709f9e9ada776cf2877c38b.png";